/* CUSTOM_SWATCHPROP_BY_CLAUDE — live read-out for the `swatches` custom-option block.

   The control itself needs no JS: it is a radio group named `properties[<label>]` bound to the
   product form, so a checked radio posts the colour straight to /cart/add. This file only keeps
   the legend's "Frame Color: <value>" text in step with the circle the customer picked, matching
   what variant-picker.js does for real variant swatches (updateSwatchLabel).

   Delegated from the document, so it survives any section swap without re-binding -- the labels
   block and the product-info column are both replaced wholesale on a variant change, and a
   directly-bound listener would die with them (the same trap that killed the Room Designer badge
   animation; see assets/custom-room-designer-badge.js). */
(function () {
  'use strict';
  if (window.__bsfsSwatchPropBound) return;
  window.__bsfsSwatchPropBound = true;

  function sync(input) {
    var selector = input.closest('.option-selector--custom');
    if (!selector) return;
    var readout = selector.querySelector('.js-swatch-prop-value');
    if (readout) readout.textContent = input.value;
  }

  document.addEventListener('change', function (evt) {
    var input = evt.target;
    if (!input || input.type !== 'radio') return;
    if (!input.classList.contains('opt-btn')) return;
    sync(input);
  });

  /* A preselected radio is correct in the markup already, but quick-buy and any other clone of
     this block can arrive with a different one checked -- reconcile once the DOM settles. */
  function reconcile() {
    document.querySelectorAll('.option-selector--custom .opt-btn:checked').forEach(sync);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
  document.addEventListener('on:variant:change', reconcile);
})();
